export const pdfTools = [

  {
    id: 1,
    name: "PDF to Word",
    route: "/pdf-to-word",
    description: "Convert PDF files into editable Word documents"
  },

  {
    id: 2,
    name: "JPG to PDF",
    route: "/jpg-to-pdf",
    description: "Convert JPG images into PDF"
  },

  {
    id: 3,
    name: "PDF to JPG",
    route: "/pdf-to-jpg",
    description: "Convert PDF pages into JPG images"
  },

  {
    id: 4,
    name: "Merge PDF",
    route: "/merge-pdf",
    description: "Merge multiple PDF files into one"
  },

  {
    id: 5,
    name: "Split PDF",
    route: "/split-pdf",
    description: "Split PDF pages into separate files"
  },

  {
    id: 6,
    name: "Compress PDF",
    route: "/compress-pdf",
    description: "Reduce PDF file size"
  },

  {
    id: 7,
    name: "Protect PDF",
    route: "/protect-pdf",
    description: "Add password protection to PDF"
  },

  {
    id: 8,
    name: "Unlock PDF",
    route: "/unlock-pdf",
    description: "Remove PDF password protection"
  }

];


// ADD THIS
export const categories = [];


// ADD THIS
export const pricingPlans = [];
